import React from 'react';
import { RefreshCw } from 'lucide-react';
import { Button } from '../ui/button';

export const AdminAccessStatus = ({ policy, testid }) => <div data-testid={`${testid}-status`}>
  <p role={policy.error ? 'alert' : 'status'} data-testid={`${testid}-message`}>{policy.error || 'Checking admin access…'}</p>
  {policy.error && <Button type="button" variant="outline" onClick={policy.reload} data-testid={`${testid}-retry`}><RefreshCw size={16} />Retry</Button>}
</div>;